/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Delete_Event_CancelInputs */

const en_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_shortcut_keys_delete_event_cancel = /** @type {(inputs: Shortcut_Keys_Delete_Event_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Shortcut_Keys_Delete_Event_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_delete_event_cancel = /** @type {((inputs?: Shortcut_Keys_Delete_Event_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Delete_Event_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "de") return de_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "it") return it_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "ru") return ru_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "es") return es_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "ja") return ja_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "hi") return hi_shortcut_keys_delete_event_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_delete_event_cancel(inputs)
	return en_shortcut_keys_delete_event_cancel(inputs)
});